module.exports = __webpack_public_path__ + "static/media/mujer.0eac9308.png";